module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ShareTab"
  }, [_c('share-items', {
    staticClass: "ShareTab-items"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba85e616"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShareTab.vue
// module id = 792
// module chunks = 1474